/**
 * Re-run ``refresh`` when ``count`` GROWS (debounced) while ``enabled`` — e.g. the Context "N new items not yet in
 * context" count re-fetches when a teammate's / an agent's message lands live over AppSync (MODES.md §3). A burst
 * of messages = ONE call after ``delayMs`` of quiet. The server stays the source of truth for the number (what
 * counts is "after the build watermark"), so we re-fetch rather than add locally.
 */
import { useEffect, useRef } from 'react';

export default function useRefreshOnGrowth(count, enabled, refresh, delayMs = 1000) {
  const last = useRef(count);
  const timer = useRef(null);
  const fn = useRef(refresh);
  fn.current = refresh;
  useEffect(() => {
    const grew = count > last.current;
    last.current = count;
    if (!enabled || !grew) return;
    if (timer.current) clearTimeout(timer.current);
    timer.current = setTimeout(() => { timer.current = null; fn.current(); }, delayMs);
  }, [count, enabled, delayMs]);
  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);
}
